export default __webpack_public_path__ + "static/media/pop.7b1d063d.mp3";